import { render, staticRenderFns } from "./cooperationList.vue?vue&type=template&id=248c7c22&scoped=true"
import script from "./cooperationList.vue?vue&type=script&lang=js"
export * from "./cooperationList.vue?vue&type=script&lang=js"
import style0 from "./cooperationList.vue?vue&type=style&index=0&id=248c7c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c7c22",
  null
  
)

export default component.exports